<template>
  <div class="targetLearnerParent">
    <slot></slot>
    <div class="divContent">
      <div v-for="(item, index) in details" :key="index" class="divItem">
        <div class="divContainer">
          <img v-lazy="{
            src:item.image.url,
            loading: require('./../../../../../assets/wheelplanting.jpg'),
          }" alt="" />
          <div class="divTitle">{{ item.title }}</div>
          <div
            v-for="(v, i) in item.description.split(' ')"
            :key="i"
            class="divDesc"
          >
            {{ v }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    details: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/targetLearnerWidge";
</style>
